import { createMap } from 'cadenza/map/custom/custom-map-utils';
import { getSelectorLayerActions } from 'cadenza/map/layer-actions/selector-layer-actions';

export function createSelectorMap (target, options) {
  return createMap(
    target,
    {
      ...options,
      layerActionProvider: getSelectorLayerActions
    });
}
